var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-5"},[_c('div',[_c('iframe',{staticClass:"responsive-iframe",attrs:{"src":"http://chat.appyaqui.com/#/chat/1"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }